let global = {
  apiversion : 1,
};

export default global;